import SeparatorLine from './SeparatorLine';

export default SeparatorLine;
